import React from 'react';

import { Tooltip } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  text: React.ReactNode;
  placement?: TooltipPlacement;
  isNew?: boolean;
}

const HelpTip = ({ text, placement = 'top', isNew }: IProps) => {
  return (
    <Tooltip title={text} placement={placement}>
      <Icon.CircleHelp size={16} className={isNew ? 'text-(--uizz-antd-color-text-secondary)' : undefined} />
    </Tooltip>
  );
};

export default HelpTip;
